module.exports = __webpack_public_path__ + "static/media/c239ebd2f8682f2e7aa22d210f61b9e0.555f60a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/posters/c239ebd2f8682f2e7aa22d210f61b9e0.jpg
// module id = 267
// module chunks = 0